import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const HostEventCheckin = lazy(() => import("@/pages/HostEventCheckin"));

export const Route = createFileRoute("/host/event/$eventId")({
  component: HostEventCheckin,
});
